import React from 'react';
import './src/styles/global.css';
import BackgroundGlow from './src/components/layout/BackgroundGlow';

export const wrapPageElement = ({ element }) => (
  <>
    <BackgroundGlow />
    {element}
  </>
);
